module.exports = __webpack_public_path__ + "img/bench-arrangement.ee7426d6.jpg";